import { Button } from "PFComponents/button";
import { Tooltip } from "PFComponents/tooltip";
import { useMatchesInvalidate } from "PFCore/hooks/queries/matches/use_matches_invalidate";
import { useDateFormatter } from "PFCore/hooks/use_date_formatter";
import { fetchMatches } from "PFCore/services/matches";
import { Id } from "PFCore/types";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { useActivityMatches } from "../hooks/use_activity_matches";

type RefreshActionProps = {
  activityId?: Id;
  onUpdate: VoidFunction;
  showLabel?: boolean;
  qaId?: string;
};

const RefreshAction = ({ activityId, onUpdate, showLabel = true, qaId }: RefreshActionProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const { invalidate: invalidateMatches } = useMatchesInvalidate();
  const { formatDateTime } = useDateFormatter();
  const { t } = useTranslation("activities");

  const { matchesMeta } = useActivityMatches();

  const lastRefreshAt =
    matchesMeta?.timestamps && "matchedAt" in matchesMeta.timestamps
      ? matchesMeta.timestamps.matchedAt
      : null;
  const tooltipMessage =
    lastRefreshAt && t("show.iconsTooltips.lastUpdated", { date: formatDateTime(lastRefreshAt) });

  if (!activityId) {
    return null;
  }

  const handleUpdate = async () => {
    setIsLoading(true);
    try {
      await fetchMatches(activityId, { refresh: true });
      await invalidateMatches();
      onUpdate && onUpdate();
    } catch {}
    setIsLoading(false);
  };

  return (
    <Tooltip content={tooltipMessage}>
      <Button
        icon="refresh"
        disabled={isLoading}
        text={showLabel ? t("show.parts.refreshMatches") : undefined}
        onClick={handleUpdate}
        kind="secondary"
        qaId={qaId}
      />
    </Tooltip>
  );
};

export default RefreshAction;
